import { ApolloLink, type TypePolicies } from "@apollo/client";

export const createRootTrackingKeyLink = (trackingKey?: string) =>
  new ApolloLink((operation, forward) => {
    if (!trackingKey) {
      return forward(operation);
    }
    const context = operation.getContext();

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    context.headers = {
      ...context?.headers,
      "indeed-root-tracking-key": trackingKey,
    };
    operation.setContext(context);
    return forward(operation);
  });

type HttpHeader = {
  name: string;
  value: string;
};

export const createHttpHeaderLink = (headers: HttpHeader[]) =>
  new ApolloLink((operation, forward) => {
    if (headers.length === 0) {
      return forward(operation);
    }
    const context = operation.getContext();

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    context.headers = {
      ...context?.headers,
      ...headers.reduce(
        (acc, header) => {
          acc[header.name] = header.value;
          return acc;
        },
        {} as Record<string, string>,
      ),
    };
    operation.setContext(context);
    return forward(operation);
  });

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getJsInterviewPrepOccupations: {
        merge(existing, incoming) {
          // Merge supportedOccupations and recommendedOccupations separately
          // since they come from different queries but same GraphQL field

          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
          return {
            ...existing,
            ...incoming,
          };
        },
      },
    },
  },
  Job: {
    keyFields: ["key"],
  },
  JobSeekerProfile: {
    keyFields: ["accountKey"],
  },
};
